import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { X } from "@phosphor-icons/react";

export default function AuthModal() {
  const { modalOpen, setModalOpen, login } = useAuth();
  const [email, setEmail] = useState("");

  if (!modalOpen) return null;

  const handleGoogleLogin = () => {
    login();
  };

  const handleEmailLogin = (e) => {
    e.preventDefault();
    login();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center" data-testid="auth-modal">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={() => setModalOpen(false)}
      />

      <div className="relative w-full max-w-sm mx-4 bg-zinc-950 border border-zinc-800 p-8" data-testid="auth-modal-content">
        <button
          onClick={() => setModalOpen(false)}
          className="absolute top-4 right-4 text-zinc-500 hover:text-zinc-300 transition-colors"
          data-testid="auth-close-btn"
        >
          <X size={18} weight="bold" />
        </button>

        <div className="mb-6">
          <p className="text-[10px] tracking-[0.25em] uppercase font-mono text-emerald-500/80 mb-2">
            Halal Screener
          </p>
          <h2 className="text-xl font-light text-zinc-100 mb-1">
            Sign In to Your Account
          </h2>
          <p className="text-xs text-zinc-500 leading-relaxed">
            Save your portfolio, sync across devices, and unlock premium analytics.
          </p>
        </div>

        <button
          onClick={handleGoogleLogin}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-zinc-700 bg-zinc-900 text-zinc-100 hover:bg-zinc-800 hover:border-zinc-600 transition-colors text-sm font-mono"
          data-testid="google-login-btn"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" className="shrink-0">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        <div className="flex items-center gap-3 my-5">
          <div className="flex-1 h-px bg-zinc-800" />
          <span className="text-[10px] font-mono text-zinc-600 uppercase">or</span>
          <div className="flex-1 h-px bg-zinc-800" />
        </div>

        <form onSubmit={handleEmailLogin}>
          <label className="text-[10px] tracking-[0.2em] uppercase font-mono text-zinc-500 mb-1.5 block">
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full border border-zinc-700 bg-zinc-900 px-4 py-2.5 text-sm font-mono rounded-none shadow-none focus:outline-none focus:ring-1 focus:ring-zinc-400 placeholder:text-zinc-600 text-zinc-100 mb-3"
            data-testid="email-input"
          />
          <button
            type="submit"
            className="w-full py-2.5 text-[11px] font-mono uppercase tracking-wider bg-zinc-100 text-zinc-900 hover:bg-zinc-300 transition-colors"
            data-testid="email-login-btn"
          >
            Continue with Email
          </button>
        </form>

        <p className="text-[10px] text-zinc-600 mt-5 leading-relaxed text-center">
          By continuing, you agree to our privacy policy. We only use your email for authentication.
        </p>
      </div>
    </div>
  );
}
